import { resizeObservers } from '../utils/resizeObservers';
/**
 * Checks to see if there are any active observations.
 *
 * https://drafts.csswg.org/resize-observer-1/#has-active-observations-h
 */
var hasActiveObservations = function () {
    return resizeObservers.some(function (ro) { return ro.activeTargets.length > 0; });
};
export { hasActiveObservations };
